import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TipoDocumentacionCamViewModel {
    public Id: number | null;
    public Descripcion: string;
    public Orden: number;
    public Activo = false;
}

export class TipoDocumentacionCamItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TipoDocumentacionCamItemViewModel[];
}

export class TipoDocumentacionCamItemViewModel {
    public Id: number | null;
    public Descripcion: string;
    public Orden?: number;
    public Activo = false;
}

export class FilterSearchingTipoDocumentacionCamViewModel extends FilterSearchingBaseViewModel {
    public Id: number | null;
    public Descripcion: string;
    public Orden: number;
    public Activo = false;
}
